export default __webpack_public_path__ + "static/media/twitter.d0fe627a.svg";